import { gql } from '@apollo/client';

export const UPDATE_PICKUP_APPOINTMENT = gql`
  mutation UpdatePickupAppointment($input: UpdatePickupAppointmentInput!) {
    updatePickupAppointment(input: $input)
  }
`;

export const UPDATE_COMPLETED_PICKUP_APPOINTMENT = gql`
  mutation UpdateCompletedPickupAppointment($input: UpdatePickupAppointmentInput!) {
    updateCompletedPickupAppointment(input: $input)
  }
`;

export interface UpdatePickupAppointmentInput {
  appointmentId: string;
  taskId: string;
  actualParcelCount: number;
  actualParcelUnit: number;
  photosS3KeysJson: string[];
  actualPickupDate: string;
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
  /** BOL 提货单图片 S3 密钥，一单一张 */
  bolS3Key?: string;
  /** 揽收备注：司机现场填写，落在 BOL 的 Notes 栏 */
  driverRemark?: string;
  /** 是否部分揽收；不传按「全部揽收」处理，status 仍是 PICKED_UP */
  isPartialPickup?: boolean;
  /** 部分揽收原因：1-部分货物未准备好，2-车辆装不下，3-其他；仅 isPartialPickup 为 true 时有意义 */
  partialPickupReason?: number;
  /** 现场逐件扫描到的运单号；不传表示本次不更新扫描记录 */
  trackingNumbers?: string[];
  /** 无法扫描时司机填写的原因，与运单号同表留痕 */
  unscannableReason?: string;
  /** 扫描时司机 GPS（打开扫描页时取一次，取不到则不传） */
  scanLatitude?: number;
  scanLongitude?: number;
  // ==== 揽收站点 2.0 现场回传 ====
  // 这三个字段原先走第二次调用 submitPickupOnsiteFeedback，那次调用被 siteV2Enabled 门住，
  // 弱网/缓存未命中时整段被跳过，站点建联状态与现场联系人一起静默丢失。
  // 并进主请求后：一次提交一次落库，离线重传也自动带上（队列里存的就是这个 input）。
  /** 现场联系人姓名；不传即不更新，不会覆盖服务端已有值 */
  onsiteContactName?: string;
  /** 现场联系方式；不传即不更新 */
  onsiteContactPhone?: string;
  /** 上门备注（写入站点建联跟进时间线）。与 driverRemark 不同，后者落在 BOL 的 Notes 栏 */
  onsiteNote?: string;
}

export interface UpdatePickupAppointmentVariables {
  input: UpdatePickupAppointmentInput;
}

export interface UpdatePickupAppointmentResponse {
  updatePickupAppointment: boolean;
}

export interface UpdateCompletedPickupAppointmentResponse {
  updateCompletedPickupAppointment: boolean;
} 